import React, {FC} from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import {PageTitle} from '../../../_metronic/layout/core'
import ChartBeranda from '../../../_metronic/partials/widgets/charts/ChartBeranda'
import ChartBerandaPie from '../../../_metronic/partials/widgets/charts/ChartBerandaPie'

const BerandaChartPage: FC = () => {
  const [satuanKerjaCode, satuanKerjaName] = useSelector<RootState>(({auth}) => {
    return [
      auth.user?.pegawaiData.administrative_unit_id,
      auth.user?.pegawaiData.administrative_name,
    ]
  }) as string[]
  return (
    <>
      <div className='row gy-4 mb-4'>
        <div className='col-12'>
          <div className='card bg-danger'>
            <div className='card-header align-items-center border-0'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='fw-bolder mb-2 text-light fs-2'>{satuanKerjaName}</span>
                <span className='text-light fw-bold fs-6'>{satuanKerjaCode}</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        {/* begin::Row */}
        <div className='col-12'>
          <ChartBeranda className='card-xl-stretch mb-xl-8' />
        </div>

        {/* end::Row */}
      </div>
      <div className='row'>
        <div className='col-12'>
          <ChartBerandaPie className='card-xl-stretch mb-xl-8' />
        </div>
      </div>
    </>
  )
}

const BerandaChartWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Beranda Chart</PageTitle>
      <BerandaChartPage></BerandaChartPage>
    </>
  )
}

export {BerandaChartWrapper}
